import { render, staticRenderFns } from "./EventCreationModal.vue?vue&type=template&id=15ed24e2&scoped=true"
import script from "./EventCreationModal.vue?vue&type=script&lang=ts"
export * from "./EventCreationModal.vue?vue&type=script&lang=ts"
import style0 from "./EventCreationModal.vue?vue&type=style&index=0&id=15ed24e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15ed24e2",
  null
  
)

export default component.exports